export type PromptCategory =
  | 'Strategy'
  | 'Research'
  | 'Design'
  | 'Analysis'
  | 'Documentation'
  | 'Ideation'
  | 'Productivity'
  | 'Other';

export type PromptStatus = 'published' | 'pending' | 'rejected';

export type AgentTool = 'Copilot' | 'Rovo';

export interface Prompt {
  id: number;
  title: string;
  description: string;
  category: PromptCategory;
  prompt_text: string;
  tags: string[];
  upvotes: number;
  downvotes: number;
  view_count: number;
  status: PromptStatus;
  submitted_by?: string;
  created_at: string;
  approved_at?: string;
  approved_by?: string;
}

export interface Agent {
  id: number;
  title: string;
  description: string;
  category: PromptCategory;
  tool: AgentTool;
  link: string;
  upvotes: number;
  downvotes: number;
  view_count: number;
  status: PromptStatus;
  submitted_by?: string;
  created_at: string;
  approved_at?: string;
  approved_by?: string;
}

export interface Vote {
  id: number;
  user_ref: string;
  item_id: number;
  item_type: 'prompt' | 'agent';
  vote_type: 'up' | 'down';
  created_at: string;
}

export interface Comment {
  id: number;
  item_id: number;
  item_type: 'prompt' | 'agent';
  item_title?: string;
  comment_text: string;
  submitted_by?: string;
  created_at: string;
}

export interface PromptSubmission {
  title: string;
  description: string;
  category: PromptCategory;
  prompt_text: string;
  tags: string[];
}

export interface AgentSubmission {
  title: string;
  description: string;
  category: PromptCategory;
  tool: AgentTool;
  link: string;
}

export const CATEGORIES: PromptCategory[] = [
  'Strategy',
  'Research',
  'Design',
  'Analysis',
  'Documentation',
  'Ideation',
  'Productivity',
  'Other',
];

export const CATEGORY_COLORS: Record<
  PromptCategory,
  { bg: string; text: string }
> = {
  Strategy: { bg: 'rgba(124, 58, 237, 0.30)', text: '#374151' },
  Research: { bg: 'rgba(37, 99, 235, 0.30)', text: '#374151' },
  Design: { bg: 'rgba(219, 39, 119, 0.30)', text: '#374151' },
  Analysis: { bg: 'rgba(22, 163, 74, 0.30)', text: '#374151' },
  Documentation: { bg: 'rgba(234, 88, 12, 0.30)', text: '#374151' },
  Ideation: { bg: 'rgba(202, 138, 4, 0.30)', text: '#374151' },
  Productivity: { bg: 'rgba(8, 145, 178, 0.30)', text: '#374151' },
  Other: { bg: 'rgba(107, 114, 128, 0.30)', text: '#374151' },
};
